import WaterfallAdd from './container';

export default WaterfallAdd;
